<template>
    <div class="wrap">
        <h1>회원가입</h1>
        <div class="signup">
            <h2>1단계. 개인정보</h2>
            <ul class="signup-list">
                <li class="clearfix">
                    <label for="signup-name_chk">회원구분 <em>*</em></label>
                    <div class="signup-name-chk">
                        <input type="radio" name="signup_type" id="signup_type" v-model="pharm.is_pharmacy" value="1">
                        <span class="signup-name-chk-notice">약국</span>
                        <!-- &nbsp;&nbsp;&nbsp;&nbsp;
                        <input type="radio" name="signup_type" id="signup_type" v-model="pharm.is_pharmacy" value="0">
                        <span class="signup-name-chk-notice">약사</span> -->
                    </div>
                </li>                
                <li class="clearfix">
                    <label for="user-email">이메일 <em>*</em></label>
                    <div class="email-group clearfix">
                        <div>
                            <input type="email" name="signup-email" id="signup-email" v-model="pharm.email" v-validate="'required|email'">
                            <p v-show="errors.has('signup-email')" class="error-msg">이메일 형식이 아닙니다.</p>
                        </div>
                    </div>
                </li>
                <li class="clearfix">
                    <label for="signup-name">약국명 <em>*</em></label>
                    <div>
                        <input type="text" name="signup-name" id="signup-name" v-model="pharm.pharm_name" v-validate="'required|min:2'">
                        <p v-show="errors.has('signup-name')" class="error-msg">약사(약국)명은 2자 이상 입력하셔야 합니다.</p>
                    </div>
                </li>
                <li class="clearfix">
                    <label for="signup-pw">비밀번호 <em>*</em></label>
                    <div>
                        <input type="password" name="signup-pw" id="signup-pw" v-model="pharm.pass" v-validate="'required'" ref="signup-pw">
                        <p class="signup-notice">* 영문/숫자/특수문자 조합 8자 이상</p>
                        <p v-show="errors.has('signup-pw')" class="error-msg">필수 입력 사항입니다.</p>
                    </div>
                </li>
                <li class="clearfix">
                    <label for="signup-pw2">비밀번호 확인 <em>*</em></label>
                    <div>
                        <input type="password" name="signup-pw2" id="signup-pw2" v-model="pharm.pass_re" v-validate="'required|confirmed:signup-pw'">
                        <p v-show="errors.has('signup-pw2')" class="error-msg">패스워드가 동일하지 않습니다.</p>
                    </div>
                </li>
                <!-- <li v-if="dr.is_hospital=='Y'" class="clearfix">
                    <label for="signup-hosp-name">원장의사명 <em>*</em></label>
                    <div>
                        <input type="text" name="signup-hosp-name" id="signup-hosp-name" v-model="dr.hosp_dr_name" v-validate="'min:2'">
                        <p class="signup-notice"> ( 병원일 경우 필수 ) </p>
                        <p v-show="errors.has('signup-hosp-name')" class="error-msg">의사명은 2자 이상 입력하셔야 합니다.</p>
                    </div>
                </li> -->
                <!--
                <li class="clearfix">
                    <label for="signup-manager-name">관리자명 </label>
                    <div>
                        <input type="text" name="signup-manager-name" id="signup-manager-name" v-model="dr.hosp_manager" v-validate="'min:2'">
                        <p class="signup-notice">* 병원일 경우</p>
                        <p v-show="errors.has('signup-manager-name')" class="error-msg">관리자명은 2자 이상 입력하셔야 합니다.</p>
                    </div>
                </li>
                -->
                <li class="clearfix">
                    <label for="phone-group">휴대폰 <em>*</em></label>
                    <div>
                        <select name="tel-num1" id="tel-num1"
                                v-validate="'required|numeric'" v-model="pharm.nation_code" size="1">
                            <option value="">선택</option>
                            <option value="82">한국</option>
                            <option value="1">미국</option>
                        </select>
                        <span class="phone-br">-</span>                   
                        <input type="tel" name="tel-num2" id="tel-num2"
                               v-validate="'required|min:10|numeric'" v-model="pharm.contact">
                        <p style="color:red" v-show="errors.has('tel-num1')||errors.has('tel-num2')" class="error-msg">휴대폰 번호는 10자리 이상이어야 합니다.</p>
                    </div>
                </li>

                <li class="clearfix">
                    <label for="verify-code">인증번호 <em>*</em></label>
                    <div class="verify-code clearfix">
                        <div>
                            <input type="text" name="verify-code" id="verify-code" v-model="verify_no" v-validate="'required'">
                            <div class="signup-next-btn-side">
                                <button @click="request_verify_no">인증번호 발송</button>
                            </div>
                            <p v-show="errors.has('verify-code')" class="error-msg">필수 입력 사항입니다.</p>
                        </div>
                    </div>
                </li>
            </ul>
            <div class="signup-btn-group">
                <ul class="signup-link">
                    <li><a href="#" @click.prevent="view_terms('1')">이용약관</a></li>
                    <li><a href="#" @click.prevent="view_terms('2')">개인정보 취급방침</a></li>
                </ul>
                <div class="signup-chk">
                    <input type="checkbox" name="signup-chk" id="signup-chk" v-model="is_agree_terms">
                    <label for="signup-chk">이용약관 및 개인정보 취급방침을 확인하였으며 모두 동의합니다.</label>
                </div>
                <div class="signup-next-btn">
                    <!-- <button @click="onNext">다음</button> -->
                    <button @click="onNext">가입신청</button>
                </div>
            </div>
        </div>
        <el-dialog
          title="엠디톡(MDtalk) 이용약관"
          :visible.sync="dialogTermsServiceVisible"
          width="80%">
          <!--<span>This is a message</span>-->
          <terms-service></terms-service>
          <span slot="footer" class="dialog-footer">
            <!--<el-button @click="dialogVisible = false">Cancel</el-button>-->
            <el-button type="primary" @click="dialogTermsServiceVisible = false">확인</el-button>
          </span>
        </el-dialog>
        <el-dialog
          title="개인정보 처리방침"
          :visible.sync="dialogTermsPrivacyVisible"
          width="80%">
          <!--<span>This is a message</span>-->
          <terms-privacy></terms-privacy>
          <span slot="footer" class="dialog-footer">
            <!--<el-button @click="dialogVisible = false">Cancel</el-button>-->
            <el-button type="primary" @click="dialogTermsPrivacyVisible = false">확인</el-button>
          </span>
        </el-dialog>
    </div>
</template>

<script>
    import TermsPrivacy from './TermsPrivacy'
    import TermsService from './TermsService'
    import { STATUS_CODE } from '@/lib/constants'

  export default {
    name: 'step1',
    data() {
      return {
        dialogTermsServiceVisible: false,
        dialogTermsPrivacyVisible: false,
        pharm: {
          email: null,
          pharm_name: null,
          pass: null,
          pass_re: null,
          contact: '',
          nation_code: '',
          is_pharmacy: 1
        },
        is_agree_terms: false,
        is_sent_verify_no: false,
        verify_no: '',
      }
    },
    methods: {
      view_terms(service_type) {
        let url = '';
        if(service_type == '1') url = 'https://images.mdtalk.io/node/test/static/doc/terms.html';
        else if(service_type == '2') url = 'https://images.mdtalk.io/node/test/static/doc/privacy_01.html';
        else {
          alert('서비스 준비중입니다.');
          return;
        }

        window.open(url,"view_terms","width=1050,height=800");

      },
      async request_verify_no () {
        if(!this.pharm.contact){
            alert('휴대폰 번호를 입력해 주세요.');
            return false;
        }
        
        let {data} = await this.axios.post('/auth/dr/send_ver_only', this.pharm)
        let {resp} = data

        if(data.status !== STATUS_CODE.OK){
            return alert(data.msg);
        }else{
            alert('카카오 알림톡으로 인증번호 전송 되었습니다.(유효시간 : 30분)')
        }
        //alert('인증번호 전송이 되었습니다(유효시간: 30분) : '+ resp.verify_no)
        this.is_sent_verify_no = true
      },
      async onNext () {
        let is_form_valid = await this.$validator.validateAll();
        //console.log(this.errors.any());

        if (!this.is_agree_terms) {
          alert('회원가입은 이용약관 동의가 필수 입니다.');
          return false;
        }

        let post_data = { phone_no: this.pharm.contact, verify_no: this.verify_no };
        let {data} = await this.axios.post('/auth/dr/check_ver', post_data);
        let {resp} = data;

        if (data.status !== STATUS_CODE.OK){
            return alert(data.msg);
        }
        
        if (is_form_valid) {
          // console.log(JSON.parse(JSON.stringify(this.pharm)))
          this.$emit('onNext', this.pharm)
        } else {
          alert('입력내용을 다시 확인해 주세요!')
          return false;
        }
      },
    },
    mounted() {
    },
    components: { TermsPrivacy, TermsService }
  }
</script>

<style scoped>
    .wrap {
        width: 100%;
        height: 100%;
        padding: 30px 0;
        background-color: #f5f6fa;
    }

    .wrap h1 {
        color: #474747;
        text-align: center;
        letter-spacing: -.5px;
        font: 400 32px 'Noto Sans KR', sans-serif;
    }

    .signup {
        width: 100%;
        max-width: 700px;
        padding: 30px;
        position: relative;
        background-color: #fff;
        border: 1px solid #eee;
        box-sizing: border-box;
        margin: 30px auto 30px;
    }

    .signup h2 {font: 400 20px 'Noto Sans KR', sans-serif;}
    .signup-list {margin: 20px 0 45px;}
    .signup-list li {margin-bottom: 20px;}

    .signup-list li > label {
        width: 140px;
        position: relative;
        font: 400 16px/50px 'Noto Sans KR', sans-serif;
    }

    .signup-list li > label em {
        color: #ff316d;
        position: absolute;
        top: 5px;
        margin-left: 5px;
    }

    .signup-list li > label,
    .signup-list li > input,
    .signup-list li > div,
    .signup-list li > select,
    .phone-group > select,
    .phone-group .phone-br,
    .phone-group input {float: left;}
    .signup-list input {width: 280px;}

    .signup-list input,
    .signup-list select {
        height: 50px;
        padding: 0 15px;
        box-sizing: border-box;
        border: 1px solid #d2d2d2;
    }

    .signup-list .signup-notice {
        color: #afafaf;
        margin-top: 10px;
        font: 400 14px 'Noto Sans KR', sans-serif;
    }

    .signup-list select {font: 400 16px 'Noto Sans KR', sans-serif;}
    #signup-name, #signup-pw, #signup-pw2 {width: 440px}

    #user-email,
    .email-group .email-br,
    #email-account {float: left;}

    .email-group .email-br {
        margin: 0 10px;
        font: 500 16px/50px 'Noto Sans KR', sans-serif;
    }

    .signup-link {font-size: 0;}
    .signup-link > li {
        height: 30px;
        text-align: center;
        display: inline-block;
        border: 1px solid #746ce6;
        font: 500 14px/30px 'Noto Sans KR', sans-serif;
    }

    .signup-link > li a {color: #746ce6;}

    .signup-link > li:first-child {width: 100px; margin-right: 10px;}
    .signup-link > li:last-child {width: 120px;}
    .signup-chk {margin: 10px 0 40px;}

    .signup-btn-group {
        /* margin-left: 140px; */
        text-align: center;
    }
    #signup-chk {display: none;}

    #signup-chk + label {
        display: inline-block;
        text-indent: 30px;
        position: relative;
        white-space: nowrap;
        font: 400 16px 'Noto Sans KR', sans-serif;
    }

    #signup-chk + label::before {
        content: '';
        display: block;
        width: 20px;
        height: 20px;
        box-sizing: border-box;
        border: 1px solid #d2d2d2;
        position: absolute;
        left: 0;
        top: 50%;
        transform: translateY(-50%);
    }

    #signup-chk:checked + label::before {
        border-color: #736ee6;
        background: url(../../assets/home/checked.png) center center/14px no-repeat;
    }

    .signup-next-btn {
        width: 150px;
        height: 50px;
        margin:0 auto;
        background-color: #746ce6;
    }

    .signup-next-btn button {
        color: #fff;
        width: 100%;
        height: 100%;
        border: none;
        outline: 0;
        cursor: pointer;
        text-align: center;
        background-color: transparent;
        font: 400 16px/50px 'Noto Sans KR', sans-serif;
    }

    .signup-next-btn-side {
        display: inline-block;
        width: 150px;
        height: 50px;
        margin:0 auto;
        background-color: #746ce6;
    }

    .signup-next-btn-side button {
        color: #fff;
        width: 100%;
        height: 100%;
        border: none;
        outline: 0;
        cursor: pointer;
        text-align: center;
        background-color: transparent;
        font: 400 16px/50px 'Noto Sans KR', sans-serif;
    }

    #verify-code{
        width: 250px;
        height: 50px;
        border: 1px solid #d2d2d2;
        margin-right: 5px;
        font: 500 16px/50px 'Noto Sans KR', sans-serif;
    }

    #tel-num1 {
        width: 80px;
        padding: 0 15px;
        font: 400 16px 'Noto Sans KR', sans-serif;
        background: url(../../assets/home/select.png) 90% no-repeat;
    }

    #tel-num2 {
        font: 400 16px 'Noto Sans KR', sans-serif;
    }

    #specialty_id {
        width: 286px;
        padding: 0 15px;
        font: 400 16px 'Noto Sans KR', sans-serif;
        background: url(../../assets/home/select.png) 95% no-repeat;
    }

    #signup-email, #signup-name, #signup-pw, #signup-pw2{
        width: 400px;
        height: 50px;
        border: 1px solid #d2d2d2;
        font: 500 16px/50px 'Noto Sans KR', sans-serif;
    }
    .signup-name-chk{

    }

    #signup-name-chk {
        width: 30px;
        margin: 0;
        vertical-align:middle;
    }
    #signup_type {
        width: 30px;
        margin: 0;
        vertical-align:middle;
    }
    .signup-name-chk-notice {
        display:inline-block; 
        margin-left:10px;
        vertical-align:middle;
        color:#746ce6
    } 

    /* 에러메세지 */
    .error-msg {line-height: 30px; color: #746ce5 !important;}
    .user-info .error-msg {line-height: 45px;}
    .agree .error-msg {line-height: 30px;}
</style>